import { KeyboardSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SmartPointerSensor } from '../sensors/SmartPointerSensor';

/**
 * Sostituisce il default PointerSensor con uno SmartPointerSensor
 * che evita di iniziare il drag su elementi interattivi
 */
export function useSmartSensors() {
  const pointerSensor = useSensor(SmartPointerSensor, {
    activationConstraint: {
      distance: 8,
    },
  });
  const keyboardSensor = useSensor(KeyboardSensor);

  return useSensors(pointerSensor, keyboardSensor);
}
